import jason from '../images/neonJason2.1.png';

export default function About() {
  return (
    <div className='about-page'>
        <section className="page-card title-card">
           <h1>About Jason Jacobs</h1>
        </section>

        <section className="profile-section">
            <img className="profile-photo" src={jason} alt="Jason Jacobs" />
        </section>

        <section className="text-area">
            <p>
                I started building ColdFlare Studios as a way to turn my love of games,
                programming, and worldbuilding into something real.
            </p>

            <p>
                My current focus is learning by building: releasing small games,
                improving each project, and growing the studio one step at a time.
            </p>
        </section>
        
    </div>
  );
}